function getScrollTop() {
	// 试过了IOS和红米都有document.body.scrollTop，所以其他都不要了
	var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
	return scrollTop;
}
export default {
	data() {
		return {
			limit: 0, // 防抖参数
			touchStart: {
				timeStamp: '',
			},
			touchEnd: {
				timeStamp: '',
			}
		}
	},
	mounted() {
		this.scrollControllerInit();
	},
	beforeDestroy() {
		this.scrollControllerDestory();
		this.showFixedbBox(false);
	},
	deactivated() {
		this.scrollControllerDestory();
		this.showFixedbBox(false);
	},
	methods: {
		scrollControllerInit() {
			window.addEventListener('scroll', this.scrollHandler);
			// window.addEventListener('touchstart', this.touchSHandler);
			// window.addEventListener('touchend', this.touchEHandler);
		},
		scrollHandler() {
			const st = getScrollTop()
			const nowTime = new Date().getTime()
			if (!this.scrollHandlerStartTime) {
				this.scrollHandlerStartTime = nowTime
			}
            if (nowTime - this.scrollHandlerStartTime < 200) {
				return
			}
            if (!this.scrollHandlerStart) {
				this.scrollHandlerStart = st
				return
			}
			// 小于80直接显示，或者对比前后滚动位置
			let hide = st < 80 ? false : (st > this.scrollHandlerStart)
			if (hide) {
				this.showFixedbBox(false);
			} else {
				this.showFixedbBox(true);
			}
			this.scrollHandlerStart = st
			this.scrollHandlerStartTime = nowTime
		},
		touchSHandler(e) {
			this.touchStart.point = e.changedTouches[0];
			this.touchStart.timeStamp = new Date();
		},
		touchEHandler(e) {
			this.touchEnd.point = e.changedTouches[0];
			this.touchEnd.timeStamp = new Date();
			if ((this.touchEnd.timeStamp - this.touchStart.timeStamp) > 200) {
				// 时间要求大于300ms，避免是tap
				let x = Math.abs(this.touchEnd.point.clientX - this.touchStart.point.clientX)
				let y = Math.abs(this.touchEnd.point.clientY - this.touchStart.point.clientY)

				let distance = Math.sqrt(x * x + y * y);
				if (distance < 80) {
					this.showFixedbBox(true);
				}
			}
		},
		scrollControllerDestory() {
			window.removeEventListener('scroll', this.scrollHandler);
			// window.removeEventListener('touchstart', this.touchSHandler);
			// window.removeEventListener('touchend', this.touchEHandler);
		}
	}
}



// WEBPACK FOOTER //
// ./src/mixins/scrollController.js